/* eslint-disable complexity,no-loops/no-loops,no-global-assign,no-console,no-implicit-globals,no-native-reassign */

var GettextBase = require('./Gettext');
var ListFormat = require('./ListFormat');
var Substitution = require('./Substitution');

var defaultDomain = 'indeed';

var recordTranslationForQA = function(translationKey, translatedText, context) {
    var globalThis;
    if (typeof window !== 'undefined') {
        globalThis = window;
    } else if (typeof global !== 'undefined') {
        globalThis = global;
    } else {
        return;
    }

    if (!globalThis.INDEED_STRINGS) {
        globalThis.INDEED_STRINGS = {};
    }

    if (context) {
        globalThis.INDEED_STRINGS[
            context + GettextBase.context_glue + translationKey
        ] = translatedText;
    } else {
        globalThis.INDEED_STRINGS[translationKey] = translatedText;
    }
};

var error = '';
var locale = '';
var projectName = '';

/**
 * Create a gettext client object to lookup translations from localeData.
 * Expects localeData to be a map containing translation keys and their translations in the target locale,
 * and also special keys "logger" mapping to a logger, and "" mapping to a metadata head object.
 * Translation key is typically `msgctxt + '\u0004' + msgid`, but it may also be a DLB2 hash of that if salt is set.
 * The head object can set keys "Plural-Forms", salt and id_length for DLB2 key hashing. id_length truncates the hash.
 * The client is responsible for ensuring hashing and truncating does not cause collisions in the translation map.
 * Plural-Forms must be a valid po file directive similar to "nplurals=2; plural=n != 1;".
 * Translation value should be [plural_message_id, plural_translation_1, ...] in the legacy format,
 * or else [plural_translation_1, ...] in the optimized format. plural_message_id is never used.
 * Iff salt is set, the translations map is expected to be in an optimized format.
 * Also see javadevs bin/po/po2json and optimize_javascript_translations.py
 *
 * Example (unoptimized po2json)
 * localeData = {
 *     "": {
 *       "plural-forms": "nplurals=2; plural=n != 1;",
 *     },
 *     "homepage\u0004hello world",: [null, "Hallo Welt"],
 *     "homepage\u0004{0} job",: ["{0} jobs", "{0} Stellenangebot", "{0} Stellenangebote"],
 * }
 *
 * Example (optimized)
 * localeData = {
 *     "": {
 *       "plural-forms": "nplurals=2; plural=n != 1;",
 *       salt: 5381,
 *       id_length: 6,
 *     },
 *     "32324": ["Hallo Welt"],
 *     "662352": ["{0} Stellenangebot", "{0} Stellenangebote"],
 * }
 */
var Gettext = function(localeData, opts) {
    if (typeof localeData === 'undefined') {
        console.error("Please provide locale data! For example, this['indeed.i18n.localeData']");
        if (opts && opts.onError) {
            opts.onError();
        }
    }

    var gt = new GettextBase({
        domain: defaultDomain,
        locale_data: { indeed: localeData },
        logger: opts && opts.logger
    });

    error = '';
    locale = '';
    projectName = '';
    try {
        locale = localeData[''].Locale;
        projectName = localeData['']['Project-Name'];
    } catch (e) {
        error = e;
    }

    var module = {
        gettext: function(msgId, args) {
            var translatedText = gt.gettext(msgId);
            recordTranslationForQA(msgId, translatedText);

            return args ? Substitution.substitution(translatedText, args) : translatedText;
        },
        pgettext: function(msgCtxt, msgId, args) {
            if(msgCtxt.length === 0) console.error("msgCtxt should not be empty in pgettext!");
            var translatedText = gt.pgettext(msgCtxt, msgId);
            recordTranslationForQA(msgId, translatedText, msgCtxt);

            return args ? Substitution.substitution(translatedText, args) : translatedText;
        },
        ngettext: function(msgId, msgIdPlural, n, args) {
            var translatedText = gt.ngettext(msgId, msgIdPlural, n);
            if (n <= 1) {
                recordTranslationForQA(msgId, translatedText);
            } else {
                recordTranslationForQA(msgIdPlural, translatedText);
            }

            return args ? Substitution.substitution(translatedText, args) : translatedText;
        },
        npgettext: function(msgCtxt, msgId, msgIdPlural, n, args) {
            if(msgCtxt.length === 0) console.error("msgCtxt should not be empty in npgettext!");
            var translatedText = gt.npgettext(msgCtxt, msgId, msgIdPlural, n);
            if (n <= 1) {
                recordTranslationForQA(msgId, translatedText, msgCtxt);
            } else {
                recordTranslationForQA(msgIdPlural, translatedText, msgCtxt);
            }

            return args ? Substitution.substitution(translatedText, args) : translatedText;
        },
        formatlist: function(listFormat, items) {
            return ListFormat.format(listFormat, items);
        },
        getListFormatPattern: function(listFormat, listLength) {
            return ListFormat.getPattern(listFormat, listLength);
        },
        findTranslation: function(msgCtxt, msgId) {
            var result = gt.findTranslation(defaultDomain, msgCtxt, msgId);

            return result
                ? { found: !!result.found, isTranslated: !!result.isTranslated }
                : { found: false, isTranslated: false };
        }
    };

    module.split = {
        gettext: function(msgId, args) {
            return Substitution.splitSubstitution(module.gettext(msgId), args);
        },
        pgettext: function(msgCtxt, msgId, args) {
            return Substitution.splitSubstitution(module.pgettext(msgCtxt, msgId), args);
        },
        ngettext: function(msgId, msgIdPlural, n, args) {
            return Substitution.splitSubstitution(module.ngettext(msgId, msgIdPlural, n), args);
        },
        npgettext: function(msgCtxt, msgId, msgIdPlural, n, args) {
            return Substitution.splitSubstitution(
                module.npgettext(msgCtxt, msgId, msgIdPlural, n),
                args
            );
        }
    };

    return module;
};

module.exports = Gettext;
